export default __webpack_public_path__ + "5_download_pl.png";